export default "__VITE_PUBLIC_ASSET__92eaab6c__"